import React from "react";
import { observer } from "mobx-react-lite";
// import { Form, Image } from "react-bootstrap";
// import Fuse from "fuse.js";
import RoleCard from "./RoleCard";
// import { SearchBar } from "../elements/styles";
import { useStore } from "../../../store";
// import roles from "../../../assets/data/role.json";
// import search from "../../../assets/icons/search.svg";

const RoleFilter = observer(({ desktop }) => {
  const { searchStore } = useStore();
  const { roles } = searchStore;

  // const [data, setData] = useState(roles);

  // const searchData = (pattern) => {
  //   if (!pattern) {
  //     setData(roles);
  //     return;
  //   }
  //   const fuse = new Fuse(data, {
  //     keys: ["rolel1", "rolel2.rolel2"],
  //   });

  //   const result = fuse.search(pattern);
  //   const matches = [];
  //   if (!result.length) {
  //     setData([]);
  //   } else {
  //     result.forEach(({ item }) => {
  //       matches.push(item);
  //     });
  //     setData(matches);
  //   }
  // };

  return (
    <div>
      {/* <SearchBar onChange={(e) => searchData(e.target.value)}>
        <Form.Control
          type="search"
          id="search-tablet-role"
          data-testid="search-input-tablet"
          className="search-filter"
          placeholder="Type to search"
          aria-label="Search"
          aria-describedby="basic-addon1"
        />

        <button className="search-button" type="submit">
          <Image src={search} />
        </button>
      </SearchBar> */}

      {roles.map((item) => {
        return <RoleCard item={item} key={item.rolel1} desktop={desktop} />;
      })}
    </div>
  );
});

export default RoleFilter;
